import React from "react";
import {observer} from "mobx-react";
import styled from "styled-components";
import {
    FlightDatesDropdownComponent
} from "../../../flight-search/dates-selection/drop-down/flight-dates-dropdown.component";
import {
    PassengersTypesDropDownComponent
} from "../../../flight-search/passenger-types-selection/drop-down/passengers-types-drop-down.component";
import {SearchMaskBookNowButtonComponent} from "../../common/search-mask-book-now-button.component";
import {useServices} from "../../../../hooks/use-services.hook";
import {
    OriginStationDropDownComponent
} from "../../../flight-search/stations-selection/drop-down/origin-station-drop-down.component";
import {
    DestinationStationDropDownComponent
} from "../../../flight-search/stations-selection/drop-down/destination-station-drop-down.component";
import {CardBox} from "../../../../basic-components/card/card.box";
import {
    SearchMaskSwapStationsButtonLargeScreenComponent
} from "./search-mask-swap-stations-button.lage-screen.component";
import {SearchMaskTitleComponent} from "../../common/search-mask-title.component";
import {SearchMaskPsoMarketUserOptionsComponent} from "../../common/search-mask-pso-market-user-options.component";



const FieldsCardBox = styled(CardBox)`
    display: grid;
    column-gap: ${props=> props.theme.spacing.spacing20};
    row-gap: ${props=> props.theme.spacing.spacing8};
    grid-template-columns: 2fr 1.2fr 1fr 0.7fr;
    grid-template-rows: repeat(2, auto);
    padding: ${props => props.theme.spacing.spacing24};
    align-items: stretch;
    justify-content: stretch;
    justify-items: stretch;
    width: 100%;
`

const TitleBox = styled(SearchMaskTitleComponent)`
    grid-column: 1/2;
    grid-row: 1/2;
`

const PsoCellBox = styled.div`
    grid-row: 1/2;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
`


const SecondRowCell = styled.div`
    grid-row: 2/3;
    width: 100%;
    align-self: stretch;
    display: flex;
    flex-direction: row;
    align-items: stretch;
`


const StationsContainerBox = styled.div`
    position: relative;
    display: flex;
    flex-direction: row;
    width: 100%;
    gap: 0;
`

const OriginStation = styled(OriginStationDropDownComponent)`
    border-top-right-radius: unset;
    border-bottom-right-radius: unset;
    padding-right: ${props => props.theme.spacing.spacing30};
    flex-basis: 50%;
`

const DestinationStation = styled(DestinationStationDropDownComponent)`
    border-top-left-radius: unset;
    border-bottom-left-radius: unset;
    padding-left: ${props => props.theme.spacing.spacing30};
    flex-basis: 50%;
`



export const SearchMaskWebappLageScreenComponent: React.FC = observer(() => {
    const services = useServices();

    const searchController = services.flightSearch.searchController;

    const renderSwapStationsButton = () => {
        if(searchController.isOriginReadonly || searchController.isDestinationReadonly) {
            return null;
        }

        return (<SearchMaskSwapStationsButtonLargeScreenComponent/>);
    }

    return (
        <FieldsCardBox>
            <TitleBox/>
            <PsoCellBox style={{gridColumn:'2/3'}}>
                <SearchMaskPsoMarketUserOptionsComponent searchController={searchController} mode={"popper"}/>
            </PsoCellBox>
            <SecondRowCell>
                <StationsContainerBox>

                    <OriginStation/>

                    {renderSwapStationsButton()}

                    <DestinationStation/>

                </StationsContainerBox>
            </SecondRowCell>

            <SecondRowCell>
                <FlightDatesDropdownComponent/>
            </SecondRowCell>

            <SecondRowCell>
                <PassengersTypesDropDownComponent/>
            </SecondRowCell>

            <SecondRowCell>
                <SearchMaskBookNowButtonComponent onClick={async () => await services.flightSearch.startBooking()}/>
            </SecondRowCell>


        </FieldsCardBox>

    );
})